import { clampDaysAgo, clampTrendDays } from '../services/holdingStorage.js'

export default function ComparisonColumnControls({
  configs,
  trendDays,
  onChange,
  onTrendDaysChange,
}) {
  const updateConfig = (id, patch) => {
    onChange(configs.map((config) => (
      config.id === id
        ? { ...config, ...patch, daysAgo: clampDaysAgo(patch.daysAgo ?? config.daysAgo) }
        : config
    )))
  }

  return (
    <section className="controls-band" aria-label="比較欄位設定">
      <div className="comparison-control trend-control">
        <span className="control-index">趨勢線</span>
        <label>
          <span>過去 N 天</span>
          <input
            aria-label="趨勢天數"
            type="number"
            min="1"
            max="90"
            value={trendDays}
            onChange={(event) => onTrendDaysChange(clampTrendDays(event.target.value))}
          />
        </label>
        <span className="control-note">表頭切換權重 / 持有數</span>
      </div>
      {configs.map((config, index) => (
        <div className="comparison-control" key={config.id}>
          <span className="control-index">比較 {index + 1}</span>
          <label>
            <span>前 N 筆</span>
            <input
              aria-label={`比較 ${index + 1} 前 N 筆`}
              type="number"
              min="1"
              max="89"
              value={config.daysAgo}
              onChange={(event) => updateConfig(config.id, { daysAgo: event.target.value })}
            />
          </label>
          <label>
            <span>項目</span>
            <select
              aria-label={`比較 ${index + 1} 項目`}
              value={config.metric}
              onChange={(event) => updateConfig(config.id, { metric: event.target.value })}
            >
              <option value="weight">權重</option>
              <option value="shares">持有數</option>
            </select>
          </label>
        </div>
      ))}
    </section>
  )
}
